import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@lt/components';
import WhatIncludedInPrice from 'src/components/WhatIncludedInPrice';
import BubbleIncludedServices from 'src/components/Bubbles/BubbleIncludedServices';
import CurrencyFormat from 'src/components/CurrencyFormat';
import {
  pluralizeNights,
  pluralizeTouristsAcc,
} from '../../../../utils/pluralizeUtils';
import { DEFAULT_NIGHTS_COUNT, DEFAULT_TOURISTS_COUNT } from '../../constants';

const PriceFixedButton = ({
  price,
  hotelLink,
  nightsCount,
  touristsCount,
  isHotelOnly,
}) => {
  const buttonSubtext = `На ${nightsCount} ${pluralizeNights(nightsCount)},
    на ${touristsCount} ${pluralizeTouristsAcc(touristsCount)} ${
    isHotelOnly ? '' : 'с перелётом'
  }`;
  const hasPrice = Boolean(price);
  const showTooltip = hasPrice;

  return (
    <StyledFixedContainer>
      <StyledContainer>
        <StyledHintContainer>
          {showTooltip ? (
            <BubbleIncludedServices placement="bottom">
              <WhatIncludedInPrice />
            </BubbleIncludedServices>
          ) : null}
        </StyledHintContainer>
        <Link href={hotelLink}>
          <StyledButton primary size="large">
            {hasPrice ? (
              <>
                {isHotelOnly ? 'Выбрать номер от ' : 'Выбрать тур от '}
                <CurrencyFormat value={price} />
                <StyledButtonText>{buttonSubtext}</StyledButtonText>
              </>
            ) : (
              `Выбрать ${isHotelOnly ? `номер` : `тур`} `
            )}
          </StyledButton>
        </Link>
      </StyledContainer>
    </StyledFixedContainer>
  );
};

const Link = styled.a`
  text-decoration: none;
  width: 100%;
`;

const StyledFixedContainer = styled.div`
  position: fixed;
  z-index: 100;
  bottom: 0;
  left: 0;
  width: 100%;
`;

const StyledContainer = styled.div`
  padding: 8px 10px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${(props) => props.theme.colors.beige};
`;

const StyledHintContainer = styled.div`
  margin-bottom: 5px;
  display: flex;
  font-size: 12px;
  color: ${(props) => props.theme.colors.greyLight};
`;

const StyledButton = styled(Button)`
  position: relative;
  width: 100%;
  font-size: 18px;
`;

const StyledButtonText = styled.div`
  font-size: 11px;
  font-weight: normal;
  color: ${(props) => props.theme.colors.blackLight};
`;

PriceFixedButton.defaultProps = {
  price: null,
  nightsCount: DEFAULT_NIGHTS_COUNT,
  touristsCount: DEFAULT_TOURISTS_COUNT,
};

PriceFixedButton.propTypes = {
  price: PropTypes.number,
  hotelLink: PropTypes.string.isRequired,
  nightsCount: PropTypes.number,
  touristsCount: PropTypes.number,
};

export default PriceFixedButton;
